<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">Inventory Will Expired 
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="2">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 pr-2">Expired within </span></b-input-group-prepend>
                <b-form-input  v-model="filter.withindays" type="number"></b-form-input>
                <b-input-group-append>
                  <span class="input-group-text" >days</span>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col md="6">
            <b-input-group >
                <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                <b-form-select
                  v-model="filter.kodeacc"
                  :plain="true"
                  :options="headCategories"
                ></b-form-select>
                <b-input-group-append><b-button class="btn btn-success ml-2" @click="getData()"> <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <div class="report-wraper mt-2">
        <table style="width: 100%;">
          <thead>
            <tr>
                <th width="300px" rowspan="2">Master Item </th>
                <th width="150px" rowspan="2">Category</th>
                <th width="80px" rowspan="2">Receipt date</th>
                <th width="150px" rowspan="2">PO. Number <br>& Supplier DO#</th>
                <th width="150px" rowspan="2"> Store & <br> Shelft/Rack</th>
                <th colspan="3" style="text-align:center;">ENDING BALANCE</th>
                <th width="150px" rowspan="2">Expired Date</th>
            </tr>
            <tr>
                <th width="80px">Qty Avail</th>
                <th width="80px">On Transfer</th>
                <th width="120px">Value ({{uanguser}})</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="(row, index ) in detaildata" :key="index">
                  <td >{{row.partnumber}} | {{row.itemname}}</td>
                  <td>{{row.nmcategory}} | {{row.headcategory}}</td>
                <td><span v-if="row.recivDate"> {{row.recivDate | moment("DD MMM YYYY")}}</span></td>
                <td>{{row.purcOrderNo}}
                    <span v-if="row.vndShipNo">&nbsp;,&nbsp; {{row.vndShipNo}}</span>
                    <p>{{row.vendorinfo}}</p>
                </td>
                <td>
                    {{row.namaStore}}
                    <p style="margin:0; padding:0;">{{row.shelfNo}}</p>
                  </td>

                  <td style="text-align:right">{{row.qtyAvail | numFormat('0,0.00')}} {{row.invunitom}}</td>
                  <td style="text-align:right">({{row.qtyTransfer | numFormat('0,0.00')}})</td>
                  <td style="text-align:right">{{row.invValue | numFormat('0,0.00')}}</td>
                <td>
                    <p v-if="row.expirDate" style="margin:0; padding:0;">{{row.expirDate | moment("DD MMM YYYY")}}</p>
                    <p style="margin:0; padding:0;">{{row.days}} days</p>
                  </td>
              </tr>
            </tbody>
        </table>
      </div>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable  title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid  #D1D1D1;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
            tbody tr:hover {
                background-color: rgba(0, 0, 0, 0.05) !important;
                cursor: default;
            }
        }
    }
 
</style>

<script>
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
// import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";
import logistic_rpt from "../../apis/logistic_rpt";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  // mixins: [validationMixin],
  // validations: {
  //   filter: {
  //       tgl1: { required },
  //       tgl2: { required },
  //       headcategory:{ required },
  //   },
  // }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      filter: {kodeacc:'',headcategory:'', withindays:30},
      uanguser: this.$store.state.user.matauang,
      monthLabels:dropdown.monthLabels,
      smrydata : [],
      detaildata : [],
      subtotal : {posting : -1},
        headCategories:[],
        itemCategories:[]
    };
  },
  components: {VueMonthlyPicker,Loading},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
  watch:{
      "filter.kodeacc": function(newval) {
          this.filter.headcategory="";
          this.filter.headcategory=this.headCategories.find(d => d.value === newval).text;
      },
  },

  created: async function(){
        const [a,b] = await Promise.all([logistic_rpt.inventorygroup(),logistic_rpt.group()]) ;
        this.itemCategories = b; 
      this.headCategories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        this.getData();
  },  
  methods: {
    getData: async function() {
      //   if (this.invalidFilter) {
      //       toastr.error('Please fill the form correctly.');
      //  } else {
        this.isLoading=true;
        try {
          const result = await logistic_rpt.expired(this.filter);
          // console.log('result',result)
          // this.smrydata =  result[0];
          this.detaildata = result[0];
        } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
        }
        this.isLoading=false;      
      //  }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await logistic_rpt.expiredexport(this.filter);
            this.isLoading=false;    
        } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
